import { ConfigStateService, ListService } from '@abp/ng.core';
import { ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import { EXTENSIONS_IDENTIFIER } from '@abp/ng.theme.shared/extensions';
import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { eIdentityComponents, UsersComponent } from '@volo/abp.ng.identity';
import { IdentityRoleService, IdentityUserService, OrganizationUnitService } from '@volo/abp.ng.identity/proxy';

@Component({
  selector: 'app-extended-users',
  templateUrl: './extended-users.component.html',
  styleUrls: ['./extended-users.component.scss'],
  providers: [
      ListService,
      {
          provide: EXTENSIONS_IDENTIFIER,
          useValue: eIdentityComponents.Users
      },
      {
        provide: UsersComponent,
        useExisting: ExtendedUsersComponent
      }
  ]
})
export class ExtendedUsersComponent extends UsersComponent implements OnInit {
  constructor(
    list: ListService<any>,
    confirmationService: ConfirmationService,
    service: IdentityUserService,
    fb: UntypedFormBuilder,
    toasterService: ToasterService,
    injector: Injector,
    configState: ConfigStateService,
    roleService: IdentityRoleService,
    organizationUnitService: OrganizationUnitService,
    ) {
        super(list, confirmationService, service, fb, toasterService, injector, configState, roleService, organizationUnitService);
        
    }
    
    override ngOnInit(): void {
      super.ngOnInit()
      this.filters.notActive = true
    }


    override clearFilters(): void {
      super.clearFilters();
      this.filters.notActive = true   
    }
}
